import globals from '@/globals';

export default {
  state: {
    acl: JSON.parse(JSON.stringify(globals.I.settings.acl)),
  },
  getters: {
    checkACL: ({ acl }) => (controller) => {
      const checkLoop = (c) => {
        if (!c) return false;
        if (Object.prototype.hasOwnProperty.call(acl, c)) return Boolean(acl[c]);

        const parents = c.split('/').slice(0, -1);
        return checkLoop(parents.join('/'));
      };

      return checkLoop(controller);
    },
  },
};
